var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"third"},[_c(_vm.labelName,{ref:_vm.labelName,tag:"component",attrs:{"ID":_vm.OSfailoverId},on:{"backHome":_vm.goBackHome,"fatherMethod":_vm.fatherMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }